import { defineMessages } from 'react-intl';

const messages = defineMessages({
  PublishedWorkCount: {
    defaultMessage: `{count, plural,
      one {1 artwork}
      other {{count} artworks}
    }`,
    description:
      'Label on artist card to show the number of published works the artist has.'
  },
  viewShopButtonText: {
    defaultMessage: 'View Shop',
    description: 'Call to Action button that navigates to an artist shop'
  }
});

export default messages;
